import { GlucoseUnit } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useGetGlucoseValue } from "./useGetGlucoseValue"
import { useGlucoseUnit } from "src/hooks/account"
import { round } from "src/utils"

interface InputProps {
  min: number;
  max: number;
  mgdlStep?: number;
  mmolStep?: number;
}

interface ReturnValue {
  min: number;
  max: number;
  step: number;
}

/*
 * pass mg/dL properties and it will return either those same properties, or those proeprties scaled for mmol/L
 */
export function useGlucoseInputProps(props: InputProps): ReturnValue {
  const {
    min,
    max,
    mgdlStep = 1,
    mmolStep = 0.1,
  } = props

  const glucoseUnit = useGlucoseUnit()
  const getGlucoseValue = useGetGlucoseValue()

  return useMemo(
    () => {
      const decimals = glucoseUnit === GlucoseUnit.MillimolesPerLiter ? 1 : 0

      return {
        // min and max should always be whole numbers for glucose
        min: round(
          getGlucoseValue(min),
          decimals,
        ),
        // min and max should always be whole numbers for glucose
        max: round(
          getGlucoseValue(max),
          decimals,
        ),
        step: glucoseUnit === GlucoseUnit.MillimolesPerLiter
          ? mmolStep
          : mgdlStep,
      }
    },
    [
      min,
      max,
      mgdlStep,
      mmolStep,
      glucoseUnit,
      getGlucoseValue,
    ],
  )
}
